<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 23:33:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/components/HeaderDet/index.vue
-->
<template>
  <!-- 订单详情头部信息 -->
  <div class="header_con">
    <div class="font18 font_weight500 colof line_height_25 font_mr">
      配送计划
    </div>
    <div class="font18 font_weight500 colof line_height_22">
      <span v-if="getDistributionPlan.status === 0"
        >{{ getDistributionPlan.startDate
        }}<span
          v-if="getDistributionPlan.startDate !== getDistributionPlan.endDate"
        >
          至 {{ getDistributionPlan.endDate }}</span
        ></span
      >
      <span v-if="getDistributionPlan.status === 1">已暂停配送</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getDistributionPlan() {
      return this.$store.getters.getDistributionPlan;
    }
  }
};
</script>

<style lang="less" scoped>
.header_con {
  .font_mr {
    margin: 15px auto 19px;
  }
}
</style>
